<script>
import ZhongjuKnowledgeIcon from '../../assets/images/zhongju_knowledge.svg';
import ZhongjuAgentsIcon from '../../assets/images/zhongju_agents.svg';
import ZhongjuSkuIcon from '../../assets/images/zhongju_sku.svg';
import ZhongjuBotIcon from '../../assets/images/zhongju_bot.svg';
import ZhongjuBotOffIcon from '../../assets/images/zhongju_bot_off.svg';
import ZhongjuWechatPublicAccountIcon from '../../assets/images/zhongju_wechat_public_account.svg';
import ZhongjuWechatKfIcon from '../../assets/images/zhongju_wechat_kf.svg';
import ZhongjuPackageIcon from '../../assets/images/zhongju_package.svg';

export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '20',
    },
    type: {
      type: String,
      default: 'outline',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    iconLib: {
      type: String,
      default: 'fluent',
    },
  },

  computed: {
    isZhongjuIcon() {
      return this.icon.includes('zhongju');
    },
    iconSource() {
      switch (this.icon) {
        case 'zhongju_knowledge':
          return ZhongjuKnowledgeIcon;
        case 'zhongju_agents':
          return ZhongjuAgentsIcon;
        case 'zhongju_sku':
          return ZhongjuSkuIcon;
        case 'zhongju_bot':
          return ZhongjuBotIcon;
        case 'zhongju_bot_off':
          return ZhongjuBotOffIcon;
        case 'zhongju_wechat_public_account':
          return ZhongjuWechatPublicAccountIcon;
        case 'zhongju_wechat_kf':
          return ZhongjuWechatKfIcon;
        case 'zhongju_package':
          return ZhongjuPackageIcon;
        default:
          return 'ZhongjuAgentsIcon';
      }
    },
    pathSource() {
      // To support icons with multiple paths
      const path = this.icons[`${this.icon}-${this.type}`];
      if (path.constructor === Array) {
        return path;
      }
      return [path];
    },
  },
};
</script>

<template>
  <img
    v-if="isZhongjuIcon"
    :src="iconSource"
    :width="size"
    :height="size"
    alt="Zhongju Icon"
  />
  <svg
    v-else-if="iconLib === 'fluent'"
    :width="size"
    :height="size"
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      v-for="source in pathSource"
      :key="source"
      :d="source"
      fill="currentColor"
    />
  </svg>
  <svg
    v-else
    :width="size"
    :height="size"
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g v-for="(pathData, index) in pathSource" :key="index">
      <path
        :key="pathData"
        :d="pathData"
        stroke="currentColor"
        stroke-width="1.66667"
      />
    </g>
  </svg>
</template>
